import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchMembershipThunk, fetchSubscriptionPlansThunk } from 'slices/membership/thunk'
import { AppDispatch, RootState } from 'store'
import "./style.scss"
import Loader from 'Components/Common/Loader'
import TrialPricing from 'Components/membership/pricing/TrialPricing'
import Pricing from 'Components/membership/pricing/Pricing'
import useDocumentTitle from 'hooks/useDocumentTitle'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { getErrorMessage } from 'utils/helpers'
import { cancelMembership } from 'services/api/membership'
import { analyticsLog } from 'services/analytics'
import { ANALYTICS_EVENTS } from 'constants/analyticsEvents'
import ifConfigured from 'hoc/ifConfigured'
const SubscriptionPlans = () => {

    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();

    const { membership: membershipData, subscription_plans: plansData } = useSelector((state: RootState) => state.membershipState);
    const activePlan = membershipData?.data?.active_plan ?? null;
    const selectedAgencyId = useSelector((state: RootState) => state.auth.selectedAgencyId);

    const isActivePaidPlan = useMemo(() => {
        return !(activePlan?.plan_frequency?.is_trial) && !activePlan?.plan?.default;
    }, [activePlan]);

    useDocumentTitle("Subscription Plans");

    useEffect(() => {
        dispatch(fetchMembershipThunk({ }));
        dispatch(fetchSubscriptionPlansThunk({ }));
    }, [])



    const onProceedToCheckout = async (planId: string | number, frequency: string = 'monthly') => {
        try {
            const data = {
                planId,
                frequency
            }
            const encodedData = btoa(JSON.stringify(data));
            navigate(`/subscription-plans/checkout?payload=${encodedData}`);
        } catch (error) {
            toast.error(getErrorMessage(error));
            console.log(error);
        }
    }

    const onCancelMembership = async () => {
        try {
            if (!selectedAgencyId || activePlan?.auto_renew === false) return;
            await cancelMembership(selectedAgencyId);
            analyticsLog(ANALYTICS_EVENTS.SUBSCRIPTION_CANCELED, {
                plan: activePlan?.plan?.name,
                frequency: activePlan?.plan_frequency?.frequency_slug
            });
            dispatch(fetchMembershipThunk({ force: true }));
            dispatch(fetchSubscriptionPlansThunk({ force: true }))
        } catch (error) {
            toast.error(getErrorMessage(error));
            console.log(error);
        }
    }

    if (membershipData.loading || plansData.loading) return <Loader />

    return (
        <>
            {(activePlan?.has_consumed_trial || isActivePaidPlan) ? <Pricing onCancelMembership={onCancelMembership} onProceedToCheckout={onProceedToCheckout} /> : <TrialPricing onCancelMembership={onCancelMembership} onProceedToCheckout={onProceedToCheckout} />}
        </>
    )
}

export default ifConfigured(SubscriptionPlans, 'agency_membership_subscription', '/')